$('img[usemap]').imageMap();
